import {
  authorizationFailureInterceptor,
} from '@/apis/interceptors';

export default function setup(instance) {
  instance.interceptors.response.use(...authorizationFailureInterceptor);

  return instance;
}
